export enum EmployeePositionEnum {
		None = 0,
		FirstHead = 1,
		Employee = 2
}
